import { useState } from "react";
import { Button, Tooltip } from "reactstrap";

const ButtonTip = (props) => {
  const [tooltipOpen, setTooltipOpen] = useState(false);
  const toggle = () => setTooltipOpen(!tooltipOpen);

  return (
    <>
      <Button
        className={props.className}
        type="button"
        size={props.size ?? 'md'}
        outline={props.outline}
        color={props.color}
        onClick={props.onClick}
        id={props.id}
        disabled={props.disabled}
      >
        {props.children}
      </Button>
      {props.tooltipText && (
        <Tooltip
          placement={props.tooltipDirection || "right"}
          isOpen={tooltipOpen}
          target={props.id}
          toggle={toggle}
        >
          {props.tooltipText}
        </Tooltip>
      )}
    </>
  );
};

export default ButtonTip;
